// extracted by mini-css-extract-plugin
export var addToCartButton = "_tu-b";
export var arrowButtonContainer = "_tu-9";
export var arrowButtonIcon = "_tu-a";
export var carouselArrowButton = "_tu-6";
export var carouselElementContainer = "_tu-1";
export var left = "_tu-7";
export var productDisplayCarouselContainer = "_tu-0";
export var productTileContainer = "_tu-2";
export var productTileImage = "_tu-4";
export var productTileImageContainer = "_tu-3";
export var productTileTitle = "_tu-5";
export var right = "_tu-8";
export var sliderOverflow = "_tu-c";